// extracted by mini-css-extract-plugin
module.exports = {"orderAttributes":"OrderAttributesInfo_orderAttributes__tuI_F","orderAttributesText":"OrderAttributesInfo_orderAttributesText__r2mQ2"};